import { Version } from "../components/apps-components/apps-types";

export default function checkPlatform(versions: Version[]) {
    let isIos = false;
    let isAndroid = false;
    
    versions.filter(
      (item: Version) => item.platform === "IOS"
    ).length > 0 ? isIos = true : isIos = false;

     versions.filter(
      (item: Version) => item.platform === "ANDROID"
    ).length > 0 ?  isAndroid = true : isAndroid = false;

    if (isIos && isAndroid) {
      return ("Android; iOS;" )
    } else if( !isIos && isAndroid){
      return "Android"
    }
    else if( !isAndroid && isIos){
      return "iOS"
    } else 
    return ""
  }